import React from 'react';
import { useFriendAndPartners } from '../../hooks/useFriendAndPartnerApi';
import ImagePreview from '../common/ImagePreview';

const FriendsAndPartners: React.FC = () => {
  const { data: partners, isLoading } = useFriendAndPartners();

  const activePartners = [...(partners || [])]
    .filter((p) => p.isActive && p.showOnMemberDashboard)
    .sort((a, b) => (a.displayPosition ?? 0) - (b.displayPosition ?? 0));

  if (isLoading || activePartners.length === 0) return null;

  return (
    <div className="mb-8">
      <h2 className="text-sm font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wide mb-4">
        Friends & Partners
      </h2>

      <div className="flex gap-4 overflow-x-auto pb-2 md:flex-wrap md:overflow-x-visible">
        {activePartners.map((partner) => (
          <a
            key={partner.id}
            href={partner.websiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="block shrink-0 w-[335px] h-[130px] p-4 bg-white dark:bg-gray-700 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105 overflow-hidden"
          >
            {partner.imageFileRecordId ? (
              <ImagePreview fileId={partner.imageFileRecordId} size="fll" objectFit="contain" />
            ) : (
              <div className="w-full h-full px-6 flex items-center justify-center bg-gray-100 dark:bg-gray-700">
                <span className="text-gray-600 dark:text-gray-300 font-semibold text-sm">{partner.name}</span>
              </div>
            )}
          </a>
        ))}
      </div>
    </div>
  );
};

export default FriendsAndPartners;
